import { themeVars } from '../theme/vars.ts';
import { space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { style } from '../layer.css';

export const noDataContainer = style({
  ...typography['bodyMd'],

  color: themeVars.container.foreground.secondary,
  display: 'flex',
  gap: space.s4,
  justifyContent: 'center',
  width: 'fit-content',
});
